var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      class: _vm.componentState,
      attrs: { "data-component": "base-search-input" },
    },
    [
      _c("input", {
        attrs: { placeholder: _vm.placeholderText, disabled: _vm.isDisabled },
        domProps: { value: _vm.search },
        on: { input: _vm.onSearchInput },
      }),
      _vm._v(" "),
      _c(
        "div",
        {
          class: _vm.componentState,
          attrs: { "data-button": "icon-button" },
          on: {
            click: function ($event) {
              !_vm.isDisabled && !!_vm.search && _vm.$emit("search-change", "")
            },
          },
        },
        [_c("or-icon", { attrs: { icon: _vm.searchIcon } })],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }